import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "react-bootstrap";
import Swal from "sweetalert2";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";
import { findRapportClientApi } from "../../_App/Redux/Slices/rapport/rapportSlice";
import { allOrganisationsApi } from "../../_App/Redux/Slices/organisations/organisationSlice";
import {
  findClientById,
  findNiveauxFidelite,
} from "../../_App/Redux/Slices/client/clientSlice";
import FiltreRapportClient from "../../Components/Rapport/FiltreRapportClient";
import RapportClientTable from "../../Components/Rapport/RapportClientTable";
import ClientForm from "../../Components/Client/ClientForm";

const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default function RapportClientPage() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const societe = useAppSelector(societeId);

  const today = new Date();
  const lastMonth = new Date(today);
  lastMonth.setMonth(today.getMonth() - 1);

  const defaultFiltre = {
    dateDebut: formatDate(lastMonth),
    dateFin: formatDate(today),
    searchterm: "",
  };

  const [index, setindex] = useState(1);
  const [loading, setLoading] = useState(false);
  const [filtre, setFiltre] = useState(defaultFiltre);
  const [organisationFilter, setOrganisationFilter] = useState<string[]>([]);
  const [showClientModal, setShowClientModal] = useState(false);
  const [clientItem, setClientItem] = useState<any>(null);

  useEffect(() => {
    if (societe) {
      dispatch(allOrganisationsApi(societe));
      dispatch(findNiveauxFidelite(societe));
    }
  }, [societe]);

  const fetchRapportClient = async (
    pageIndex: number,
    filtreOverride?: any,
    organisationOverride?: string[]
  ) => {
    setLoading(true);
    try {
      await dispatch(
        findRapportClientApi({
          ...(filtreOverride || filtre),
          societe_id: societe,
          organisation: organisationOverride || organisationFilter,
          index: pageIndex,
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setindex(1);
    fetchRapportClient(1);
  };

  const handleReset = () => {
    setFiltre(defaultFiltre);
    setOrganisationFilter([]);
    setindex(1);
    fetchRapportClient(1, defaultFiltre, []);
  };

  useEffect(() => {
    if (societe && organisationFilter) {
      fetchRapportClient(index);
    }
  }, [index, societe, organisationFilter]);

  const verifcationMsg = (msg: string) => {
    return Swal.fire({
      title: t("vous-êtes sûr?"),
      text: msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Confirmer!"),
      cancelButtonText: t("Cancel!"),
    }).then((result) => {
      return result.isConfirmed ? true : false;
    });
  };

  const openClientEdit = async (clientId: string) => {
    const result = await dispatch(findClientById(clientId));
    if (result.payload) {
      setClientItem(result.payload);
      setShowClientModal(true);
    }
  };

  return (
    <div>
      <Navbar />
      <FiltreRapportClient
        t={t}
        filtre={filtre}
        setFiltre={setFiltre}
        organisationFilter={organisationFilter}
        setOrganisationFilter={setOrganisationFilter}
        handleSearch={handleSearch}
        handleReset={handleReset}
      />
      <ClientForm
        t={t}
        verifcationMsg={verifcationMsg}
        ShowModal={showClientModal}
        setShowModal={setShowClientModal}
        client={clientItem}
        setClient={setClientItem}
        onSuccess={() => fetchRapportClient(index)}
      />
      <RapportClientTable
        t={t}
        index={index}
        setindex={setindex}
        loading={loading}
        onClickClient={openClientEdit}
      />
    </div>
  );
}
